var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section"},[_vm._m(0),(_vm.registered)?_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"})]):_c('div',{staticClass:"columns"},[_c('div',{staticClass:"column"})])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"columns is-mobile"},[_c('div',{staticClass:"column"},[_c('h1',{staticClass:"title"},[_vm._v("Warranty Registration")])])])
}]

export { render, staticRenderFns }